import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../../components/Navigation/Navigation';
import { updateName } from '../../../actions/personalInfoAction';
import NameFields from '../../../components/Fields/NameFields';
import FormValidator from '../../../utils/FormValidator';
import { ValidateInput } from '../../../utils/Validation';
import withBackgroundImage from '../../../HOC/withBackgroundImage';
import debounce from 'debounce';

import TagManager from 'react-gtm-module'

import './Name.scss';

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Personal Info',
      event: 'Credit Card Step 2'
  }
}

class Name extends Component {
  constructor(props) {
    super(props);

    this.validator = new FormValidator([
      { 
        field: 'firstName', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, first name is required' 
      },
      { 
        field: 'firstName', 
        method: ValidateInput,         
        validWhen: true, 
        message: 'Oops, first name contains invalid characters.' 
      },
      { 
        field: 'firstName', 
        method: 'isLength', 
        args: [{min:0, max: 35}],
        validWhen: true, 
        message: 'Oops, first name is too long, Please shorten to 35 characters.' 
      },
      { 
        field: 'middleName', 
        method: 'isLength', 
        args: [{min:0, max: 35}],
        validWhen: true, 
        message: 'Oops, middle name is too long, Please shorten to 35 characters.' 
      },
      { 
        field: 'middleName', 
        method: ValidateInput,         
        validWhen: true, 
        message: 'Oops, middle name contains invalid characters.' 
      },      
      { 
        field: 'lastName', 
        method: 'isEmpty', 
        validWhen: false, 
        message: 'Oops, last name is required' 
      },
      { 
        field: 'lastName', 
        method: ValidateInput,         
        validWhen: true, 
        message: 'Oops, last name contains invalid characters.' 
      },
      { 
        field: 'lastName', 
        method: 'isLength', 
        args: [{min:0, max: 35}],
        validWhen: true, 
        message: 'Oops, last name is too long, Please shorten to 35 characters.' 
      },      
    ]);

    this.state = {
      firstName: this.props.firstName || "",
      middleName: this.props.middleName || "",
      lastName: this.props.lastName || "",
      validation: this.validator.valid()
    };

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this)
  }

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs)
  }

  onClickForward(event) {
    event.preventDefault();
    this.setState({validation: this.validator.validate(this.state)}, () => {
      if(this.state.validation.isValid) {
        this.props.history.replace('/PersonalInfo/Birthdate');
      }
    });
  }
  onClickBackward() {
    this.props.history.replace('/RatesFees');
  }
  updateName = debounce(() => {
    this.props.updateName(this.state.firstName, this.state.middleName, this.state.lastName)
  }, 1000);
  handleChange(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
      [event.target.name]:event.target.value
    }, () => {
      //debounce(this.props.updateName(this.state.firstName, this.state.middleName, this.state.lastName), 1000);
      this.updateName();
    });
  }
  validateField(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)}
    });
  }
  render() {
    return (
      <div className="personal-info-name">
        <h1>Let’s get to know you</h1>
        <h3>Please enter your legal name.</h3>
        <Form onSubmit={this.onClickForward}>
          <NameFields handleChange={this.handleChange} validateField={this.validateField} {...this.state} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.personalInfo
});

const mapDispatchToProps = dispatch => ({
  updateName: (firstName, middleName, lastName) => dispatch(updateName(firstName, middleName, lastName))
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("know-you")(Name));


// WEBPACK FOOTER //
// ./src/containers/PersonalInfo/Name/Name.js